import init_sticky_footer_cta from './sticky_footer_cta/init';

export default function init_footer() {
    
    init_sticky_footer_cta();
    init_scroll_to_top();

    document.addEventListener('toggle_height_init', close_footer_dropdowns)
}

function init_scroll_to_top(){

    const btn = document.querySelector('.scroll_to_top_btn');

    if( !btn ) return;

    btn.addEventListener('click', ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    })
}

function close_footer_dropdowns(){

    document.removeEventListener('toggle_height_init', close_footer_dropdowns)

    if( screen.width > 768 ) return;

    document.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open').forEach(dropdown=>{
        dropdown.click();
    })
}